import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "react-responsive-modal";
// import Responsive from 'react-responsive';
import "../../views/common/helloava.css";
import "../../views/common/animate.css";
import "../../components/review/reviewProduct.css"
import AppHeader from "../../components/header/AppHeader";
import Footer from "../../components/footer/Footer";
import SideMenu from "../../components/hair/sidemenu/SideMenu";
import HairPopupModal from "../../components/hair/popup/HairPopupModal";
import * as aaUtil from "../../ath/utils/aaUtils";
import Api from '../../utils/api';
import { isMobile,isJSON } from "../../utils/util";
import { utils } from "redux-saga";
import {getUserCartData} from '../../actions/cartAction';
const noFooter = ["/signin", "/reset-password", "/create-password"];


class FlexLayout extends Component {
  constructor() {
    super();

    this.state = {
      showBanner: true,
      showOriginalBannerMessage: true,
      showHairPopup: false,
      showHair: false,
      bannerContent: '',
    };
  }
  orderStyle = {
    order: 2,
    showFirstTimeMessage: false
  };

  componentDidMount() {
    if (window.location.pathname.includes("/hair/")) aaUtil.mountAdobeScript();
    this.checkIfShowBanner();
    aaUtil.mountPaypalScript();

    window.addEventListener("storage", this.updateMessage);

    this.fun_getBannerText()
    let _this = this;

    let orderRegimenCard =  localStorage.getItem("orderRegimenCard")
    if(!!orderRegimenCard){
      if(isJSON(orderRegimenCard)){
        let orderRegimenCardObj = JSON.parse(orderRegimenCard);
        Api.fun_submitOrderCard(orderRegimenCardObj['orderId'],orderRegimenCardObj['imageBase64']);
      }
    }
    
    // if(isMobile(navigator.userAgent)){
    //   document.onscroll=function(){
    //     var scrollTop=document.documentElement.scrollTop||document.body.scrollTop;
    //     var oDiv=document.getElementById('promo-banner');
    //     if(scrollTop >= 85){
    //       oDiv.style.display = 'none'
    //     }else{
    //       oDiv.style.display = 'block';
    //       _this.fun_PhoneBranchTopPosition();
    //     }
    //   }
    // }

    window.onresize = function (){
      try {
        this.fun_PhoneBranchTopPosition();
      } catch (error) {}
    }
  }

  fun_PhoneBranchTopPosition(){
    var oDiv;
    if(!isMobile(navigator.userAgent) && window.location.pathname == "/" ){
        oDiv = document.getElementById('promo-banner');
    }else{
        oDiv = document.getElementById('promo-banner-container-second');
    }

    var content = document.getElementById('content-container');
    try {
      var bannerHeight = oDiv.offsetHeight;
      content.style.paddingTop = (bannerHeight)+"px";
      document.getElementById("phone-recommendations-navigation-area").style.top =  document.getElementById("promo-banner-container-second").offsetHeight +'px';
      } catch (error) {}

      try {
        let overDom = document.getElementsByName("newBoardingThankView");
        if(overDom){
          let height1 = document.getElementById('promo-banner-container-second').offsetHeight
          overDom[0].style.top = (height1+47)+'px';
          let stepsDom = document.getElementsByClassName("quiz-steps-container");
          stepsDom[0].style.top = (height1)+'px';
        }
      } catch (error) {}


  }


  componentDidUpdate(prevProps) {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
      this.checkIfShowBanner();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.updateMessage);
  }

  fun_getBannerText(){
    fetch("/api/last-banner", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }).then(response => response.json())
      .then(responseJson => {

        this.setState({
          bannerContent: responseJson.content
        },()=>{
          setTimeout(this.fun_PhoneBranchTopPosition(),2000);
        })

    }).catch(function(error) {
        console.log(error)
    });
  }
  

  updateMessage = () => {
    if (
      !localStorage.getItem("auth_token") ||
      localStorage.getItem("first_time_purchase")
    ) {
      this.setState({
        showOriginalBannerMessage: true
      });
    } else {
      this.setState({ showOriginalBannerMessage: false });
    }
  };

  /*** HAIR POPUP ***/
  renderHairPopup = showHair => {
    this.setState({ showHairPopup: true, showHair: showHair });
  };

  handleCloseHairPopup = () => {
    this.setState({ showHairPopup: false });
  };

  /*** END HAIR POPUP ***/

  checkIfShowBanner() {
    const isAuthenticated =
      this.props.isAuthenticated || !!localStorage.getItem("auth_token");
    const isFirstTime = localStorage.getItem("first_time_purchase");
    const hasPurchased = localStorage.getItem("has_purchased");

    if (isAuthenticated) {
      if (
        localStorage.getItem("user_has_hair_profile") &&
        !localStorage.getItem("user_has_skin_profile")
      ) {
        this.setState({ showBanner: false });
        return;
      } else if (isFirstTime) {
        this.setState({ showOriginalBannerMessage: true });
        return;
      } else if (hasPurchased) {
        this.setState({ showOriginalBannerMessage: false });
        return;
      } else if (!isFirstTime && !hasPurchased) {
        this.checkIfPreviouslyPurchased();
      }
    } else {
      this.setState({ showOriginalBannerMessage: true, showBanner: true });
    }
  }

  checkIfPreviouslyPurchased() {
    const userId = localStorage.getItem("user_id");
    var token = Api.auth_tokenManager();
    fetch("/api/user-orders/extended-with-products?user-id=" + userId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": token
      }
    })
      .then(response => {
        if (response.status >= 400 && response.status < 500) return;
        else return response.json();
      })
      .then(responseJson => {
        let hasPurchasedProducts = responseJson.some(order => {
          return order.productList !== null;
        });
        if (
          (responseJson && responseJson.length < 1) ||
          !hasPurchasedProducts
        ) {
          if (localStorage.getItem("has_purchased"))
            localStorage.removeItem("has_purchased");
          localStorage.setItem("first_time_purchase", true);
          this.setState({ showOriginalBannerMessage: true });
        } else {
          if (localStorage.getItem("first_time_purchase"))
            localStorage.removeItem("first_time_purchase");
          localStorage.setItem("has_purchased", true);
          this.setState({ showOriginalBannerMessage: false });
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  render() {
    const urlPath = this.props.match.path;
    const showFooter = !noFooter.includes(urlPath);
    return (
      <div className={this.props.match.path !='/' ? "container-fluid": "container-fluid container-fluid-bg"  }>
        <div className="promo-banner-container">
          <div className="promo-banner-container-second" id="promo-banner-container-second">

             {this.state.showBanner ? (
              // <div className="promo-banner">
              //   {this.state.showOriginalBannerMessage
              //     ? `Take 15% off your first skincare order (on orders over $50) with code ${process.env.REACT_APP_PROMO_CODE}`
              //     : `Refill your skincare products or try something new at 10% off. Use code: REFILL10`}
              // </div>
             <div className="promo-banner" id="promo-banner" style={localStorage.getItem("visited_recommendations") == 'true' ? null: { display:'none'}  }>{this.state.bannerContent} </div>
            ) : null}
            {/* 头部的banner,先注释 */}
            <AppHeader
              renderHairPopup={this.renderHairPopup}
              location={urlPath}
              history={this.props.history}
            />
          </div>
        </div>

        {/*
										this.state.showBanner ?
										<Responsive maxWidth={ 1023 }>
												<div className="promo-banner-container">
														<div className="promo-banner">
																Take 15% off your first order (on orders over $50) with code { process.env.REACT_APP_PROMO_CODE }
														</div>
														<div className="promo-banner-spacer" />
												</div>
										</Responsive> : null
								*/}

        <div
          id="content-container"
          className={
            window.location.pathname == '/' ? 'heand-background-img' : ''
          }
          style={this.orderStyle}
        >
          <div id="container-children">
            {this.props.children}
            {showFooter && <Footer location={urlPath} />}
          </div>
        </div>
        <Modal
          open={this.state.showHairPopup}
          onClose={this.handleCloseHairPopup}
          classNames={{
            overlay: "ha-overlay hair-popup-modal-overlay",
            modal: "ha-modal hair-popup-modal"
          }}
        >
          <HairPopupModal showHair={this.state.showHair} />
        </Modal>

        {/* Google Tag Manager (noscript) */}
          <noscript>
            <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W2PNNBH"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
          </noscript>
        {/* End Google Tag Manager (noscript) */}
     
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isAuthenticated } = helloava.auth;
  return { isAuthenticated };
}

function mapDispatchToProps(dispatch) {
  return {
      getUserCartData: () => dispatch(getUserCartData()),
  };
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(FlexLayout));



// WEBPACK FOOTER //
// ./src/views/layout/FlexLayout.js